import Result from "@Core/Result";
import { ServiceBase } from "@Core/ServiceBase";
import { IFeatureFlag } from "@Models/IFeatureFlag";

export default class FeatureFlagService extends ServiceBase {
    public async getFeatureFlag(featureFlag: string): Promise<Result<IFeatureFlag>> {
        return await this.requestJson({
            url: `/api/FeatureFlag/${featureFlag}`,
            method: "GET",
        });
    }
}
